import { useContext, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { getLabel } from '../../InitData';
import { parsePrintAgg } from '../../data/data';
import { fetchBetsForTournaments } from '../../data/fetchBetsForTournaments';
import { compactBets } from '../../data/parseBetsData';
import { getConfiguration } from '../../data/utils';
import { PrematchDataContext } from '../PrematchDataFetcher';
import PrintIframeContent from './PrintIframeContent';
import { getMapFromBets } from './PrintOdds';

function getBetsToPrint(prematchData, tournaments) {
    const conf = getConfiguration();
    const sport = prematchData.sportById[tournaments[0].sportRef];
    let bets = [];

    tournaments.forEach(t => {
        const category = sport.categoryById[t.categoryRef];
        if (category == null) {
            return;
        }

        const tournament = prematchData.tournamentByUniqueId[t.uniqueId];
        if (tournament == null) {
            return;
        }

        t.sportDesc = sport.descrizione;
        t.categoryDesc = sport.categoryById[t.categoryRef].descrizione;
    });
    
    try {
        const printAggs = JSON.parse(conf.poa);
        let printAgg = printAggs[sport.id].pr[0];
        printAgg = parsePrintAgg(printAgg);
        let aggBets = printAgg.scommesse;
        if (printAgg.compattate != null && Object.values(printAgg.compattate).length > 0) {
            aggBets = compactBets(aggBets, printAgg, false);
        }
        aggBets.forEach(b => b.sportRef = sport.id);
        bets = aggBets;
    } catch(e) {}

    const betsToPrint = Object.values(getMapFromBets(bets)).sort((a, b) => {
        if (a.agRanking === b.agRanking) {
            return a.ranking - b.ranking;
        } else {
            return a.agRanking - b.agRanking;
        }
    });

    return betsToPrint;
}

function Compact(props) {
    const iframeRef = useRef(null);

    useEffect(() => {
        if (props.groups) {
            const cw = iframeRef.current.contentWindow;
            if (cw.logoLoaded === true) {
                cw.print();
            }
        }
    }, [props.togglePrint]);
    
    return (
        <iframe title="print-odds-iframe" style={{display: 'none'}} ref={iframeRef}>
            {props.groups && iframeRef.current && ReactDOM.createPortal(
                <PrintIframeContent groups={props.groups}
                                    groupByBet={props.groupByBet}
                />
                , iframeRef.current.contentWindow.document.body)}
        </iframe>
    );
}

export default function PrintOdds2(props) {
    const prematchData = useContext(PrematchDataContext);

    const [state, setState] = useState({
        groups: null,
        groupByBet: null,
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setData(groups, groupByBet) {
            this.update({groups, groupByBet});
        },
    });
    const [togglePrint, setTogglePrint] = useState(false);

    const tournamentsToPrint = props.tournaments;
    function handleClick() {
        if (tournamentsToPrint.length === 0) {
            props.setPopupSettings({
                title: getLabel('prematch_page.print_bets.error_popup.title'),
                message: getLabel('prematch_page.print_bets.error_popup.no_tournaments'),
                dismissButtonText: getLabel('prematch_page.print_bets.error_popup.confirm_button')
            });
            return;
        }
        const tournaments = [];
        let currentSport = null;
        for (let i = 0; i < tournamentsToPrint.length; i++) {
            const tournament = prematchData.tournamentByUniqueId[tournamentsToPrint[i]];
            if (currentSport == null) {
                currentSport = tournament.sportRef;
            } else if (currentSport !== tournament.sportRef) {
                props.setPopupSettings({
                    title: getLabel('prematch_page.print_bets.error_popup.title'),
                    message: getLabel('prematch_page.print_bets.error_popup.message'),
                    dismissButtonText: getLabel('prematch_page.print_bets.error_popup.confirm_button')
                });
                return;
            }
            tournaments.push(tournament);
        }
        
        const betsToPrint = getBetsToPrint(prematchData, tournaments, props.agg);
        if (betsToPrint.length === 0) {
            return;
        }
        
        fetchBetsForTournaments(tournaments, betsToPrint, 'ALL', null, null, function(resp) {
            state.setData(resp[0], resp[1]);
            if (resp[0].length > 0) {
                setTogglePrint(!togglePrint);
            }
        });
    }

    return (
        <>
            <a href-disabled="#!" role="button" tabIndex="0" onClick={handleClick} className="pointer bottone-w-sel bianco"><i className="fas fa-print"></i></a>
            <Compact togglePrint={togglePrint}
                    tournaments={props.tournaments}
                    groups={state.groups}
                    groupByBet={state.groupByBet}
            />
        </>
    );
}
